import React from 'react';
import { CheckCircle, Check } from 'lucide-react';

export default function CalculatorActions({
  selectedProposalId,
  onSubmitForApproval,
  calculationsCount = 0
}) {
  return (
    <div className="flex gap-4">
      {/* Auto-Save Status Indicator */}
      {selectedProposalId && (
        <div className="flex-1 card p-6 bg-gradient-to-r from-indigo-50 to-blue-50 border-2 border-indigo-200">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-indigo-900 mb-1 flex items-center gap-2">
                <Check className="w-5 h-5 text-green-600" />
                Auto-Saved to Proposal
              </h3>
              <p className="text-sm text-indigo-700">
                {calculationsCount} calculation{calculationsCount !== 1 ? 's' : ''} in this proposal
              </p>
            </div>
            <div className="px-4 py-2 bg-green-100 text-green-800 rounded-lg font-medium text-sm">
              ✓ Saved
            </div>
          </div>
        </div>
      )}
      
      {/* Submit for Approval Button */}
      <div className="flex-1 card p-6 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-green-900 mb-1">
              Submit for Approval
            </h3>
            <p className="text-sm text-green-700">
              Send this proposal for review
            </p>
          </div>
          <button
            onClick={onSubmitForApproval}
            className="bg-green-600 hover:bg-green-700 text-white flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap"
          >
            <CheckCircle className="w-5 h-5" />
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
